import BookingModule from './components/BookingModule'
export { default as ConfirmationModule } from "./components/ConfirmationModule";

export default BookingModule